import { Helmet } from 'react-helmet-async';

interface SEOHeadProps {
  title?: string;
  description?: string;
  keywords?: string[];
  canonical?: string;
  image?: string;
}

export const SEOHead: React.FC<SEOHeadProps> = ({
  title,
  description,
  keywords,
  canonical,
  image,
}) => {
  const baseUrl = 'https://peetrack.live';

  const fullTitle = title ? `${title} | PeeTrack` : 'PeeTrack - Urinary System Wellness Monitoring';
  const fullDescription = description || 'AI-powered fluid intake and output tracking for urinary wellness. Get intelligent insights, reminders, and analytics to manage your urinary system health with secure healthcare provider sharing.';
  const ogImage = image || `${baseUrl}/assets/peetrack_logo.png`;

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="description" content={fullDescription} />
      {keywords && keywords.length > 0 && (
        <meta name="keywords" content={keywords.join(', ')} />
      )}

      {/* OpenGraph Meta Tags (Facebook, LinkedIn) */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={fullDescription} />
      <meta property="og:url" content={canonical ? `${baseUrl}${canonical}` : window.location.href} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:site_name" content="PeeTrack" />

      {/* Twitter Card Meta Tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={fullDescription} />
      <meta name="twitter:image" content={ogImage} />

      {/* Canonical URL */}
      {canonical && <link rel="canonical" href={`${baseUrl}${canonical}`} />}

      {/* Theme Color (matches PeeTrack cyan brand) */}
      <meta name="theme-color" content="#0ea5e9" />
    </Helmet>
  );
};
